module.exports = __webpack_public_path__ + "static/media/2000_Racoons.9d3ef943.webp";